module.exports = __webpack_public_path__ + "img/77.3f431c94.jpg";